import React from 'react';
import LoadingScreen from '../UI/loading-screen';
import ErrorComponent from '../UI/error';

import SingleCard from '../UI/single-card';
import MultiCard from '../UI/multi-card';

function Product({locationData, selectMembership, languages, error, isProductLoaded, products, locationDataCurrency, couponObj, isUserLogged, businessCategories}) {
    if (error) {
        return (<ErrorComponent errorMessage ={error} />);
    } else if (!isProductLoaded) {
        return(<LoadingScreen /> )
    } else if (products && products.length > 1 && locationDataCurrency != products[0].currency_text) {
        return(<ErrorComponent errorMessage ={'You cannot purchase in '+ products[0].currency_text +". Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information."} /> )
    } else if (products && products.length <= 0) {
        return(<ErrorComponent errorMessage ={'No Memberships available.'} /> )
    } else {
        if(products && products.length > 1){
            return (
                <MultiCard 
                    languages        = {languages}
                    products         = {products}
                    selectMembership = {selectMembership}
                    couponObj        = {couponObj}
                    locationData     = {locationData}
                    isUserLogged     = {isUserLogged}
                    locationDataCurrency = {locationDataCurrency}
                    businessCategories   = {businessCategories}
                />
                
            );
        } else {
            return (
                <SingleCard 
                    languages        = {languages}
                    product          = {products}
                    selectMembership = {selectMembership}
                    couponObj        = {couponObj}
                    locationData     = {locationData}
                    isUserLogged     = {isUserLogged}
                    locationDataCurrency = {locationDataCurrency}
                    businessCategories   = {businessCategories}
                />
            );
         }    
    }
}

export default Product;